var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-controller"},[_c('div',{staticClass:"description-area"},[_c('p',[_vm._v("デザインを選択してください。（複数のデザインを選択することはできません)")])])])}]

export { render, staticRenderFns }